import { render, staticRenderFns } from "./FornecedorModule.vue?vue&type=template&id=2148edc6"
import script from "./FornecedorModule.vue?vue&type=script&lang=js"
export * from "./FornecedorModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports